module.exports = __webpack_public_path__ + "static/media/warn-circle-red.b1a7a244.svg";